/** AdhocArb mark: a sharp-edged navy tile, a white "A" whose crossbar is a balance beam. */
export const LogoMark = ({ className = "h-7 w-7", title = "AdhocArb" }) => (
  <svg viewBox="0 0 64 64" role="img" aria-label={title} className={`shrink-0 ${className}`} data-testid="logo-mark">
    <rect width="64" height="64" fill="#1E3A8A" />
    <path d="M32 11 L14 54 M32 11 L50 54" stroke="#FFFFFF" strokeWidth="6" strokeLinecap="square" fill="none" />
    <path d="M9 36 H55" stroke="#F1C77A" strokeWidth="3.5" strokeLinecap="square" />
    <path d="M9 36 L5 45 H13 Z M55 36 L51 45 H59 Z" fill="#F1C77A" />
  </svg>
);

export const BrandLockup = ({ dark = false, size = "text-xl", mark = "h-7 w-7", testId = "brand-lockup" }) => (
  <div className="flex items-center gap-2.5" data-testid={testId}>
    <LogoMark className={mark} />
    <span className={`font-display ${size} tracking-tight ${dark ? "text-white" : ""}`}>
      Adhoc<span className={dark ? "text-amber-200" : "text-blue-900 dark:text-blue-400"}>Arb</span>
    </span>
  </div>
);
